import React, {Component} from 'react';
import {FormFeedback, FormGroup, Input, Label,} from 'reactstrap';

class TextResponse extends Component {
  constructor(props) {
    super(props);
    this.state = { feedback: 'Text is required' };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    // Validate for case of edit
    this.handleInput(this.props.value.text);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ feedback: nextProps.value.text.length > 0 ? 'Text must be more than 3 characters' : 'Text is required' });
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput(value, touched) {
    const valueObject = (value.length > 3) ? { text: value, isValid: true } : { text: value };
    if (this.props.value.touched || touched) {
      valueObject.touched = true;
    }
    this.props.onValueChange(this.props.name, valueObject);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <FormGroup>
        <Label style={{whiteSpace: 'pre-wrap'}} for={this.props.name}>{this.props.prompt}</Label>
        <Input
          className={(this.props.value.touched && !this.props.value.isValid) ? 'is-invalid' : ''}
          name={this.props.name}
          onBlur={event => this.handleInput(event.target.value, true)}
          onChange={event => this.handleInput(event.target.value)}
          type="text"
          value={this.props.value.text}
        />
        <FormFeedback>{this.state.feedback}</FormFeedback>
      </FormGroup>
    );
  }
}

export default TextResponse;
